export enum SelectableAreaCategories {
  Environmental = "Environmental",
  Archaeological = "Archaeological",
  Recreational = "Recreational",
}
